import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=7ca36868"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports